import React from 'react';
import styled from 'styled-components';

import PageHeader from '#common/PageHeader';
import Flex from '#common/Flex';
import { Hidden } from 'react-grid-system';

import { ParallaxProvider } from 'react-scroll-parallax';

const SkillsWrapper = styled.section`
  ${props => props.theme.spacing.sectionBottom};
  position: relative;

  .collab__icons {
    padding: 10px 0;
    width: 12%;
    @media ${props => props.theme.media.tablet} {
      padding: 10px 0;
      width: 25%;
    }

    svg {
      color: ${props => props.theme.primaryColor};
    }
  }
  .skills__word-clouds {
    @media ${props => props.theme.media.tablet} {
      display: none;
    }

    p {
      position: absolute;
      color: ${props => props.theme.accentColor};
      z-index: -1;
      left: 0;
      right: 0;
      font-weight: 900;
    }
    z-index: -1;
  }
`;
const CreativeCoding = () => (
  <SkillsWrapper>
    <ParallaxProvider>
      <PageHeader>
        {' '}
        I'm proud to have collaborated with some <br /> awesome companies:
      </PageHeader>
      <Flex justify="space-around" align="center">
        <img
          className="collab__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599906672/Capture_uyv6wx.jpg'}
        />

        <img
          className="collab__icons"
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599906389/logo_final_ops_1_mjfkpn.svg'}
        />

        <img
          className="collab__icons"
          alt=""
          src={
            'https://res.cloudinary.com/dedozyu83/image/upload/v1599851123/t%C3%A9l%C3%A9chargement_i95vf7.png'
          }
        />


      </Flex>
      <PageHeader>

        <p style={{ textAlign: 'center', fontSize: 20 }}>
          Follow Me on{' '}
          <a href="https://www.instagram.com/samar_tekaya_official" target="__blank" rel="noreferrer noopener">
            &nbsp;Instagram.
          </a>
        </p>
      </PageHeader>

      <Flex justify="center" align="center">
        <img
          style={{ width: 200, padding: 5 }}
          alt=""
          src={
            'https://res.cloudinary.com/dedozyu83/image/upload/v1599848935/FB_IMG_1584895647391_nhbfxf.jpg'
          }
        />

        <img
          style={{ width: 200, padding: 5 }}
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599850804/119214268_1056883121430487_7678056851739614949_n_gnzflt.jpg'}
        />

        <img
          style={{ width: 200, padding: 5 }}
          alt=""
          src={'https://res.cloudinary.com/dedozyu83/image/upload/v1599850829/119138841_395555591435243_2696843379592922277_n_lbreld.jpg'}
        />

        <img
          style={{ width: 200, padding: 5 }}
          alt=""
          src={
            'https://res.cloudinary.com/dedozyu83/image/upload/v1599850827/119139840_607269983291379_1525438005495213756_n_tdgtjg.jpg'
          }
        />
      </Flex>
      <Hidden md xs sm></Hidden>
    </ParallaxProvider>
  </SkillsWrapper>
);

export default CreativeCoding;
